import { StateCreator } from "zustand";

export interface TextControlStore {
    textControlUrl?: string;
}

export interface TextControlSlice {
    textControl: TextControlStore;
    setTextControl: (state: TextControlStore) => void;
}

const initialTextControlState: TextControlStore = {};

export const createTextControlSlice: StateCreator<TextControlSlice, [], [], TextControlSlice> = (set) => ({
    textControl: initialTextControlState,

    setTextControl: (state) => set({ textControl: state }),
});
